import React from 'react';

import { GameTileProps } from '@/components/modular-grid/types';

import { GameTilesCarousel } from './GameTilesCarousel';
import { JackpotBetWidgetPropTypes } from './JackpotBetWidget';
import styles from './JackpotBetWidget.module.scss';

export interface JackpotBetWidgetGamesListPropTypes {
  games: GameTileProps[];
  carouselSpeed: number;
  onGameTileClick: JackpotBetWidgetPropTypes['onGameTileClick'];
  onGameTileInfoClick: JackpotBetWidgetPropTypes['onGameTileInfoClick'];
}

const JackpotBetWidgetGameList: React.FC<JackpotBetWidgetGamesListPropTypes> = ({
  games,
  carouselSpeed,
  onGameTileClick,
  onGameTileInfoClick,
}: JackpotBetWidgetGamesListPropTypes) => {
  return (
    <div className={styles.gameList} data-testid="jackpot-bet-games-list">
      <GameTilesCarousel
        onGameTileClick={onGameTileClick}
        onGameTileInfoClick={onGameTileInfoClick}
        games={games}
        speed={carouselSpeed}
      />
    </div>
  );
};

export default JackpotBetWidgetGameList;
